/* eslint-disable no-restricted-syntax,guard-for-in */
import $ from 'jquery';
import queryString from 'querystring';
import _t from '../../utils/translate';
import checkMetamask from "../../utils/checkMetamask";
// import putOnMarketplace from "./putOnMarketplace";
import getWallet from "../../utils/getWallet";
import claimTokens from '../../utils/claimTokens';
import claimNfsgxTokens from '../../utils/claimNfsgxTokens';
import initCountdown from '../../utils/initCountdown';
import getNfsgContract from '../../utils/getNfsgContract';
import getNfsgxContract from '../../utils/getNfsgxContract';
// import reloadMyTokens from './reloadMyTokens';
import { block, unblock } from '../../utils/blocker';
import {
  searchParse,
  updateSearch,
  setReloadDefault,
  setSearch,
} from '../../constants';

window.queryString = queryString;

let filter = null;

filter = (reload = 'ajax') => {
  setReloadDefault(reload);
  const searchString = window.location.search.substring(1, window.location.search.length);
  const search = searchParse(queryString.parse(searchString));
  setSearch(search);
  for (const key in search) {
    if (!search[key]) {
      delete search[key];
    }
  }

  initCountdown();

  // seçili filtreleri kontrol ederek frontend seçili hale getirir.
  for (const key in search) {
    for (let i = 0; i < search[key].length; i++) {
      $(`[data-key="${key}"][data-value="${search[key][i]}"]`).attr('checked', '');
      if ($(`select[data-key="${key}"]`).length) {
        $(`select[data-key="${key}"]`).val(search[key][i]);
      } else if (key === 'address') {
        $(`[data-key="address"]`).attr('checked', '');
        $(`select[data-key="address"]`).val(search[key][i]);
      }
    }
  }

  if (Object.keys(search).length > 0) {
    $('.js-filter-count').text(`(${Object.keys(search).length})`);
    $('.js-filter-reset').removeClass('d-none');
  }

  $('.js-filter-item').on('change.filter', async (e) => {
    e.preventDefault();
    delete search.keyword;
    delete search.page_no;
    const $that = $(e.currentTarget);

    let address = null;

    if ( $that.data('key') === 'address') {
      if (!await checkMetamask()) {
        return;
      }

      const ids = await getWallet();
      const accounts = await web3Client.eth.getAccounts();
      address = accounts[0];
    }

    updateSearch({
      key: $that.data('key'),
      value: $that.data('key') === 'address' ? address : String($that.data('value')),
      unique: false,
      type: $that.data('type'),
      action: $that.data('action'),
    });

    $.fancybox.close();
  });

  $('.js-filter-select-item').on('change', (e) => {
    e.preventDefault();
    const $that = $(e.currentTarget);

    updateSearch({
      key: $that.data('key'),
      value: String($that.val()),
      unique: false,
      type: 'radio',
    });
  });

  $('.js-filter-page').on('click', (e) => {
    e.preventDefault();
    const $that = $(e.currentTarget);
    updateSearch({
      key: $that.data('key'),
      value: String($that.data('value')),
      unique: false,
      type: 'radio',
    });
  });

  $('.js-open-filter-board').on('click', (e) => {
    e.preventDefault();
    const $that = $(e.currentTarget);

    $($that.data('target')).toggleClass('d-none');
  });
};

export default filter;
